import { render, staticRenderFns } from "./OrderPayment.vue?vue&type=template&id=6e8cc377&"
import script from "./OrderPayment.vue?vue&type=script&lang=ts&"
export * from "./OrderPayment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports